import { memo } from "react";

import AliPayIcon from "@/Icons/payments/alipay.svg?react";
// Import all SVG files
import AliPayPlusIcon from "@/Icons/payments/alipay-plus.svg?react";
import AmazonPayIcon from "@/Icons/payments/amazon-pay.svg?react";
import AmericanExpressIcon from "@/Icons/payments/american-express.svg?react";
import ApplePayIcon from "@/Icons/payments/apple-pay.svg?react";
import AvailabillIcon from "@/Icons/payments/availabill.svg?react";
import BancontactIcon from "@/Icons/payments/bancontact.svg?react";
import BillpayIcon from "@/Icons/payments/billpay.svg?react";
import BoncardIcon from "@/Icons/payments/boncard.svg?react";
import BonusCardIcon from "@/Icons/payments/bonus-card.svg?react";
import ButterflyCardIcon from "@/Icons/payments/butterfly-card.svg?react";
import CardGenericIcon from "@/Icons/payments/card-generic.svg?react";
import CardGenericAltIcon from "@/Icons/payments/card-generic-alt.svg?react";
import CardGenericGoldIcon from "@/Icons/payments/card-generic-gold.svg?react";
import CartesBancairesIcon from "@/Icons/payments/cartes-bancaires.svg?react";
import CembraPayIcon from "@/Icons/payments/cembrapay.svg?react";
import CrifIcon from "@/Icons/payments/crif.svg?react";
import CryptoIcon from "@/Icons/payments/crypto.svg?react";
import DankortIcon from "@/Icons/payments/dankort.svg?react";
import DinersIcon from "@/Icons/payments/diners.svg?react";
import DiscoverIcon from "@/Icons/payments/discover.svg?react";
import EloIcon from "@/Icons/payments/elo.svg?react";
import EpsIcon from "@/Icons/payments/eps.svg?react";
import GiftCardGenericIcon from "@/Icons/payments/gift-card-generic.svg?react";
import GiftCardGenericAltIcon from "@/Icons/payments/gift-card-generic-alt.svg?react";
import GiftCardGenericGoldIcon from "@/Icons/payments/gift-card-generic-gold.svg?react";
import GiropayIcon from "@/Icons/payments/giropay.svg?react";
import GooglePayIcon from "@/Icons/payments/google-pay.svg?react";
import HalfFarePlusIcon from "@/Icons/payments/half-fare-plus.svg?react";
import HipercardIcon from "@/Icons/payments/hipercard.svg?react";
import IdealIcon from "@/Icons/payments/ideal.svg?react";
import InvoiceIcon from "@/Icons/payments/invoice.svg?react";
import JCBIcon from "@/Icons/payments/jcb.svg?react";
import KlarnaIcon from "@/Icons/payments/klarna.svg?react";
import LunchCheckIcon from "@/Icons/payments/lunch-check.svg?react";
import MaestroIcon from "@/Icons/payments/maestro.svg?react";
import MaestroAltIcon from "@/Icons/payments/maestro-alt.svg?react";
import MasterCardIcon from "@/Icons/payments/mastercard.svg?react";
import MasterCardAltIcon from "@/Icons/payments/mastercard-alt.svg?react";
import MediaMarktIcon from "@/Icons/payments/mediamarkt.svg?react";
import MigrosGiftCardIcon from "@/Icons/payments/migros-giftcard.svg?react";
import MobilePayIcon from "@/Icons/payments/mobilepay.svg?react";
import PayCardIcon from "@/Icons/payments/paycard.svg?react";
import PaypalIcon from "@/Icons/payments/paypal.svg?react";
import PaysafecardIcon from "@/Icons/payments/paysafecard.svg?react";
import PointspayIcon from "@/Icons/payments/pointspay.svg?react";
import PostfinanceCardIcon from "@/Icons/payments/postfinance-card.svg?react";
import PostfinanceEfinanceIcon from "@/Icons/payments/postfinance-efinance.svg?react";
import PowerpayIcon from "@/Icons/payments/powerpay.svg?react";
import RekaIcon from "@/Icons/payments/reka.svg?react";
import SamsungPayIcon from "@/Icons/payments/samsung-pay.svg?react";
import SepaIcon from "@/Icons/payments/sepa.svg?react";
import SkrillIcon from "@/Icons/payments/skrill.svg?react";
import SwishIcon from "@/Icons/payments/swish.svg?react";
import SwissBillingIcon from "@/Icons/payments/swissbilling.svg?react";
import SwisscomPayIcon from "@/Icons/payments/swisscom-pay.svg?react";
import SwisspassIcon from "@/Icons/payments/swisspass.svg?react";
import TwintIcon from "@/Icons/payments/twint.svg?react";
import UATPIcon from "@/Icons/payments/uatp.svg?react";
import UnionPayIcon from "@/Icons/payments/unionpay.svg?react";
import VIPPSIcon from "@/Icons/payments/vipps.svg?react";
import VisaIcon from "@/Icons/payments/visa.svg?react";
import VpayIcon from "@/Icons/payments/vpay.svg?react";
import WeChatPayIcon from "@/Icons/payments/wechat-pay.svg?react";
import { BB_SVG } from "@/types/BB_SVG";

// Mapping the imported icons to their corresponding names
const svgFiles = {
	"alipay-plus": AliPayPlusIcon,
	alipay: AliPayIcon,
	"amazon-pay": AmazonPayIcon,
	"american-express": AmericanExpressIcon,
	"apple-pay": ApplePayIcon,
	availabill: AvailabillIcon,
	bancontact: BancontactIcon,
	billpay: BillpayIcon,
	boncard: BoncardIcon,
	"bonus-card": BonusCardIcon,
	"butterfly-card": ButterflyCardIcon,
	"card-generic-alt": CardGenericAltIcon,
	"card-generic-gold": CardGenericGoldIcon,
	"card-generic": CardGenericIcon,
	"cartes-bancaires": CartesBancairesIcon,
	cembrapay: CembraPayIcon,
	crif: CrifIcon,
	crypto: CryptoIcon,
	dankort: DankortIcon,
	diners: DinersIcon,
	discover: DiscoverIcon,
	elo: EloIcon,
	eps: EpsIcon,
	"gift-card-generic-alt": GiftCardGenericAltIcon,
	"gift-card-generic-gold": GiftCardGenericGoldIcon,
	"gift-card-generic": GiftCardGenericIcon,
	giropay: GiropayIcon,
	"google-pay": GooglePayIcon,
	"half-fare-plus": HalfFarePlusIcon,
	hipercard: HipercardIcon,
	ideal: IdealIcon,
	invoice: InvoiceIcon,
	jcb: JCBIcon,
	klarna: KlarnaIcon,
	"lunch-check": LunchCheckIcon,
	"maestro-alt": MaestroAltIcon,
	maestro: MaestroIcon,
	"mastercard-alt": MasterCardAltIcon,
	mastercard: MasterCardIcon,
	mediamarkt: MediaMarktIcon,
	"migros-giftcard": MigrosGiftCardIcon,
	mobilepay: MobilePayIcon,
	paycard: PayCardIcon,
	paypal: PaypalIcon,
	paysafecard: PaysafecardIcon,
	pointspay: PointspayIcon,
	"postfinance-card": PostfinanceCardIcon,
	"postfinance-efinance": PostfinanceEfinanceIcon,
	powerpay: PowerpayIcon,
	reka: RekaIcon,
	"samsung-pay": SamsungPayIcon,
	sepa: SepaIcon,
	skrill: SkrillIcon,
	swish: SwishIcon,
	swissbilling: SwissBillingIcon,
	"swisscom-pay": SwisscomPayIcon,
	swisspass: SwisspassIcon,
	twint: TwintIcon,
	uatp: UATPIcon,
	unionpay: UnionPayIcon,
	vipps: VIPPSIcon,
	visa: VisaIcon,
	vpay: VpayIcon,
	"wechat-pay": WeChatPayIcon
};

export type BB_PaymentIcon = keyof typeof svgFiles | string;
const isValidIcon = (name: string): name is keyof typeof svgFiles => name in svgFiles;

export type BB_PaymentLogoProps = {
	name: BB_PaymentIcon;
	className?: string;
};

const BB_PaymentLogo = ({ name, className }: BB_PaymentLogoProps) => {
	if (!isValidIcon(name)) {
		const IconWrapper = svgFiles["card-generic"] as BB_SVG;
		return <IconWrapper alt={name} draggable="false" className={className} title={name} />;
	} else {
		const IconWrapper = svgFiles[name] as BB_SVG;
		return <IconWrapper alt={name} draggable="false" className={className} title={name} />;
	}
};

export default memo(BB_PaymentLogo);
